import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonModule } from '../../components/button/button.module';
import { ArrowLinkModule } from '../../components/arrow-link/arrow-link.module';
import { WorldMapModule } from '../../components/world-map/world-map.module';
import { ImageWithBackdropModule } from '../../components/image/image-with-backdrop.module';

@NgModule({
  declarations: [HomeComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: HomeComponent,
        pathMatch: 'full'
      }
    ]),
    TranslocoModule,
    ButtonModule,
    ArrowLinkModule,
    WorldMapModule,
    ImageWithBackdropModule
  ]
})
export class HomeModule {}
